import React from 'react'

export default function Contact() {

    return (
        <div>
            <div className='background-contact'></div>
            <h1 className='title title-contact'>Contact</h1>
            <div className='triangle-red'></div>
            <div className='container-contact-info'>
                <h3 className='title title-email'>Email: techandy42@gmail.com</h3>
                <h3 className='title title-email'>Contact me through this email for MERN stack web development freelance requests or other programming related inquires</h3>
            </div>
        </div>
    )
}
